module.exports = __webpack_public_path__ + "static/media/YelpCamp.6f5074b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/YelpCamp.png
// module id = 53
// module chunks = 0